(function () {
  'use strict';

  function initTicker(bar) {
    if (bar.dataset.pauseOnHover !== 'true') return;
    var track = bar.querySelector('.ticker-bar__track');
    if (!track) return;

    bar.addEventListener('mouseenter', function () {
      track.classList.add('is-paused');
    });
    bar.addEventListener('mouseleave', function () {
      track.classList.remove('is-paused');
    });
  }

  function init() {
    document.querySelectorAll('.ticker-bar').forEach(initTicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var bar = e.target.querySelector('.ticker-bar');
    if (bar) initTicker(bar);
  });
})();
